/**
 * @author: Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @date: 2020-05-04
 * @description a reference to all components which can be installed.
 */

// import { XxtraHeroCarouselContainer } from "./carousels/xxtra-hero-carousel";
import { CompaniesAndOrganizations } from "./inner-pages/companies-and-organizations";
import { CompanyControllerContainer } from "./inner-pages/company/company-controller";
// import { CuratedCarouselsContainer } from "./inner-pages/curated-carousels";
import { AccountController } from "./inner-pages/account";
import { PersonControllerContainer } from "./inner-pages/person/person-controller";
import { SearchResultsGrid } from "./lists/search-results-grid";
// import { Branches } from "./page-framework/company-nav/branches";
import { FooterController } from "./page-framework/footer-controller";
import { CarouselTab } from "./panels/carousel-tab";
// import { DidWeMissSomething } from "./panels/did-we-miss-something";
// import { ItemDescriptionPanel } from "./panels/item-description-panel";
import MatricesPanel from "./panels/matrices-panel";
import { Navigate } from "./panels/navigate";
// import { OneTabPanel } from "./panels/one-tab-panel";
import { People } from "./panels/people";
import { MarketingWidget } from "./user-widgets/marketing-widget";
import { RadicalVisionary } from "./user-widgets/radical-visionary";
// import { ListsOfLists } from "./lists/vertical-lists-of-lists";
import { OnPanel } from "./panels/on-panel";
import { FeaturedItemPanelContainer } from "./panels/featured-item-panel";
import { ExternalNavbar } from "./page-framework/company-nav/external-navbar";
import { ExternalHero } from "./page-framework/company-nav/external-hero";
import { WhoWeArePanel } from "./page-framework/company-nav/whoweare-panel";
import { OurNorthSatrPanel } from "./page-framework/company-nav/northatr-panel";
import { VisionPanel } from "./page-framework/company-nav/vision-panel";
import { MatrixPanel } from "./page-framework/matrix-panel";
import { ExternalFooter } from "./page-framework/company-nav/external-footer";
import { InvitationLandingPanelContainer } from "./inner-pages/invitation/invitation-panel";
import { FiltersWidget } from "./user-widgets/filters-widget";
import { MyFollowings } from "./inner-pages/my-account/my-followings";
import { MySavedItems } from "./inner-pages/my-account/my-saved-items";
import { NewEditorials, Covidpreneurs } from "./editorials";
import { FeaturedItemPanelCarouselContainer } from "./panels/featured-item-carousel";
import { MiniHero } from "./carousels/mini-hero/index";
// import { MixedCarouselContainer } from "./panels/mixed-carousel-panel";

export const COMPONENTS: {
  [index: string]: any;
} = {
  MiniHero: {
    component: MiniHero,
  },
  //MixedCarousel: {
  //  //component: MixedCarouselContainer,
  //  props: {},
  //},
  // CuratedCarousels: {
  //   component: CuratedCarouselsContainer,
  // },
  Covidpreneurs: {
    component: Covidpreneurs,
  },
  ContactUs: {
    component: FooterController,
    props: {
      sectionName: "Support",
      tabs: ["Contact us", "Technical Issues", "FAQs", "Report an Issue"],
      tabState: ["active", "", "", ""],
      activeTab: "Contact us",
    },
  },
  TechnicalIssues: {
    component: FooterController,
    props: {
      sectionName: "Support",
      tabs: ["Contact us", "Technical Issues", "FAQs", "Report an Issue"],
      tabState: ["", "active", "", ""],
      activeTab: "Technical Issues",
    },
  },
  FAQS: {
    component: FooterController,
    props: {
      sectionName: "Support",
      tabs: ["Contact us", "Technical Issues", "FAQs", "Report an Issue"],
      tabState: ["", "", "active", ""],
      activeTab: "FAQs",
    },
  },
  ReportBug: {
    component: FooterController,
    props: {
      sectionName: "Support",
      tabs: ["Contact us", "Technical Issues", "FAQs", "Report an Issue"],
      tabState: ["", "", "", "active"],
      activeTab: "Report an Issue",
    },
  },
  PrivacyPolicy: {
    component: FooterController,
    props: {
      sectionName: "Legal",
      tabs: ["Privacy Policy", "Terms & Conditions"],
      tabState: ["active", ""],
      activeTab: "Privacy Policy",
    },
  },
  TermsAndConditions: {
    component: FooterController,
    props: {
      sectionName: "Legal",
      tabs: ["Privacy Policy", "Terms & Conditions"],
      tabState: ["", "active"],
      activeTab: "Terms & Conditions",
    },
  },

  // Branches: {
  //   component: Branches,
  // },
  // ItemDescriptionPanel: {
  //   component: ItemDescriptionPanel,
  // },
  // XxtraHeroCarousel: {
  //   component: XxtraHeroCarouselContainer,
  //   props: {},
  // },
  // ListsOfLists: {
  //   component: ListsOfLists,
  //   props: {},
  // },

  AccountSettings: {
    component: AccountController,
    props: {},
  },
  FollowingPanel: {
    component: MyFollowings,
    props: {},
  },
  SavedItemPanel: {
    component: MySavedItems,
    props: {},
  },
  // EditorialsPage: {
  //   component: NewEditorials,
  // },
  PersonDetails: {
    component: PersonControllerContainer,
  },
  CompanyDetails: {
    component: CompanyControllerContainer,
  },
  SearchPanel: {
    component: CompaniesAndOrganizations,
  },
  SearchResultsGrid: {
    component: SearchResultsGrid,
  },
  CompaniesAndOrganizations: {
    component: CompaniesAndOrganizations,
    props: {},
  },
  SearchingListPanel: {
    component: CompaniesAndOrganizations,
  },
  AboutUs: {
    component: FooterController,
    props: {
      sectionName: "Company",
      tabs: [],
      tabState: [],
      activeTab: "About us",
    },
  },
  Team: {
    component: FooterController,
    props: {
      sectionName: "Company",
      tabs: [],
      tabState: [],
      activeTab: "Team",
      location: "our-team",
    },
  },
  People: {
    component: People,
  },
  // OneTabPanel: {
  //   component: OneTabPanel,
  // },
  MatricesPanel: {
    component: MatricesPanel,
  },
  Marketing: {
    component: MarketingWidget,
  },
  CarouselTab: {
    component: CarouselTab,
  },
  // DidWeMissSomething: {
  //   component: DidWeMissSomething,
  // },
  Subscribe: {
    component: OnPanel,
  },
  RadicalVisionary: {
    component: RadicalVisionary,
  },
  Navigate: {
    component: Navigate,
  },
  SubscriptionPanel: {
    component: OnPanel,
  },
  FeaturedItemPanel: {
    component: FeaturedItemPanelContainer,
  },
  FeaturedItemPanelCarrousel: {
    component: FeaturedItemPanelCarouselContainer,
  },
  FiltersWidget: {
    component: FiltersWidget,
  },
  ExternalNavbar: {
    component: ExternalNavbar,
  },
  ExternalHero: {
    component: ExternalHero,
  },
  WhoWeArePanel: {
    component: WhoWeArePanel,
  },
  OurNorthSatrPanel: {
    component: OurNorthSatrPanel,
  },
  VisionPanel: {
    component: VisionPanel,
  },
  MatrixPanel: {
    component: MatrixPanel,
  },
  ExternalFooter: {
    component: ExternalFooter,
  },
  invitationLading: {
    component: InvitationLandingPanelContainer,
  },
};
